import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LabelIcon from '@mui/icons-material/Label';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import Popup1042S from '@/components/ui/1042SPopup';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1042S = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `<span style="color:#c1121f;font-size:18px; font-weight: 700;">Last Chance!</span> <span style="font-size:18px;">Form 1099 deadline is TODAY-</span><span style="color:#000; font-size:18px; font-weight: 600;">January 31, 2025</span><span style="font-size:18px;">! </span>`,
  //   SubHeading: 'File before it&apos;s too late!',
  //   CtaText: 'Submit Now',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099b`,
  //   isActive: true,
  // };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 2, 2));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 2, 2)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 1042-S | Foreign Income Reporting 2025"
          description="E-file IRS Form 1042-S for foreign individuals and entities. Report U.S.-source income, withholding, and exemptions securely and affordably with TaxZerone."
          keywords=""
          canonical="information-returns/efile-irs-form-1042-s/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <Popup1042S />
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background:
              'linear-gradient(92deg,rgba(51, 92, 103, 1) 0%, rgba(158, 42, 43, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'left', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                color: '#ccc',
                lineHeight: 1.3,
              }}
            >
              <strong> Attention Withholding Agents! </strong> E-file{' '}
              <b style={{ fontWeight: 600, color: '#f7ede2' }}> Form 1042-S</b>{' '}
              to report U.S. source income paid to foreign persons by March 15,
              2026.
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Form 1042-S
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1042-S</span>
                </span>{' '}
                Online
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Easily report U.S.-source income paid to foreign individuals and
                entities with TaxZerone — an IRS-authorized e-file provider
                designed for accuracy, security, and bulk compliance filing.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
                    // href="/contact-us/"
                  >
                    Start Filing Now
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/f1042s-landing-img.webp" />
                <source srcSet="/assets/images/f1042s-landing-img.png" />
                <img
                  src="/assets/images/f1042s-landing-img.png"
                  alt="E-file IRS Form 1042-S Online"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/f1042s-landing-img-sm.webp" />
                <source srcSet="/assets/images/f1042s-landing-img-sm.png" />
                <img
                  src="/assets/images/f1042s-landing-img-sm.png"
                  alt="E-file IRS Form 1042-S Online"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Starting at{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                per form, with high-volume filing rates as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 180, md: 200 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography> */}
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1042s-used-for-img.webp" />
                  <source srcSet="/assets/images/f1042s-used-for-img.png" />
                  <img
                    src="/assets/images/f1042s-used-for-img.png"
                    alt="What Is Form 1042-S Used For? "
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }} sx={{ mr: 0 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                What Is Form 1042-S Used For?
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                IRS Form <span style={{ fontWeight: 600 }}> 1042-S</span> is
                used by withholding agents to report:
              </Typography>

              <List
                sx={{
                  display: 'inline-block',
                  mb: 2,
                  ml: 2,
                }}
              >
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    U.S.-source income paid to foreign individuals, entities, or
                    intermediaries
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    The amount of federal tax withheld
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    Applicable treaty benefits or exemptions
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Reclassifications, adjustments, and corrections
                  </ListItemText>
                </ListItem>
              </List>
              <Typography variant="body1">
                The IRS uses this form to ensure proper withholding on payments
                made to foreign persons, while recipients rely on it for tax
                reporting in their home countries.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  py: { xs: 2, sm: 4, md: 4 },
                  px: { xs: 2, sm: 4, md: 6 },
                  borderRadius: 10,
                  backgroundColor: '#f5f6f7',
                  maxWidth: 850,
                  mx: 'auto',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 4,
                    textAlign: 'center',
                  }}
                >
                  Understanding U.S.-Source Income for Foreign Persons
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                  Any payment made to a nonresident alien, foreign corporation,
                  foreign partnership, foreign estate, or foreign trust that is
                  considered U.S.-source income may require Form 1042-S.
                </Typography>
                <Typography variant="body1">
                  Common types of reportable income include:{' '}
                </Typography>
                <Box
                  sx={{
                    justifyContent: 'center',
                    maxWidth: 650,
                    mx: 'auto',
                  }}
                >
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Interest and dividends
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>Royalties</ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Scholarships & fellowships
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Compensation for services
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Rents & real estate income
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>Broker proceeds</ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Prizes, awards & grants{' '}
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                  Whether the payment is taxable or exempt, the transaction must
                  usually be reported <br /> on Form 1042-S.
                </Typography>
                {/* <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 0,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                  >
                    File 1099-DA Now!
                  </Button>
                </Box> */}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                Who Must File Form 1042-S?
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                You must file{' '}
                <span style={{ fontWeight: 600 }}> Form 1042-S</span> if you are
                a <span style={{ fontWeight: 600 }}>withholding agent</span> who
                makes U.S.-source payments to foreign persons. This includes:
              </Typography>

              <List
                sx={{
                  display: 'inline-block',
                  mb: 2,
                  ml: 2,
                }}
              >
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText> Businesses of all types</ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText> Educational institutions </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>Financial institutions</ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>Government agencies</ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>Government agencies</ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>Nonprofit organizations </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>Trusts and estates </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Individuals acting as withholding agents{' '}
                  </ListItemText>
                </ListItem>
              </List>
              <Typography variant="body1" sx={{ mb: 1 }}>
                A separate{' '}
                <span style={{ fontWeight: 600 }}>
                  Form 1042-S must be filed for each recipient
                </span>{' '}
                and{' '}
                <span style={{ fontWeight: 600 }}>
                  each type of income paid
                </span>
                .
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Filing is required even when{' '}
                <span style={{ fontWeight: 600 }}>no tax was withheld,</span>{' '}
                such as payments exempt under a tax treaty or treated as
                effectively connected income (ECI).
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Payments made to{' '}
                <span style={{ fontWeight: 600 }}>
                  residents of U.S. territories
                </span>{' '}
                are generally not reportable if the beneficial owner is a U.S.
                citizen, national, or resident alien.
              </Typography>
              {/* <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                
                >
                  Stay Tuned for E-filing
                </Button>
              </Box> */}
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1042s-must-file-img.webp" />
                  <source srcSet="/assets/images/f1042s-must-file-img.png" />
                  <img
                    src="/assets/images/f1042s-must-file-img.png"
                    alt="Who Must File Form 1042-S?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                3 Easy Steps to E-file IRS Form 1042-S
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                With TaxZerone, the filing process is simple and intuitive.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/1042s-step-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/1042s-step-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/1042s-step-img.png"
                  alt="3 Easy Steps to E-file IRS Form 1042-S"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Payer & Recipient Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Payer & Recipient Information
                    </Typography>
                    <Typography variant="body1">
                      Provide withholding agent details and recipient
                      information including name, address, TIN/ITIN, and Chapter
                      3 or Chapter 4 status.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Report Income & Withholding"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Report Income & Withholding
                    </Typography>
                    <Typography variant="body1">
                      Enter the appropriate income codes, exemption codes,
                      withholding amounts, treaty benefits, and tax rates.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Review & Transmit"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Transmit
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Use built-in error checks to ensure accuracy, then
                      securely transmit your form to the IRS. Instantly send
                      recipient copies by ZeroneVault or postal mail.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
                  // href="/contact-us/"
                >
                  E-file Form 1042-S Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Powerful Features That Simplify Your 1042-S E-filing
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone is the trusted e-filing solution for businesses of all
                sizes. Here’s why:
              </Typography> */}
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS Authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Authorized
                </Typography>
                <Typography variant="body1">
                  E-file confidently through a trusted IRS-authorized provider.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Deliver Recipient Copies "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Deliver Recipient Copies
                </Typography>
                <Typography variant="body1">
                  Send secure beneficiary copies through ZeroneVault or via
                  postal mail.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Filing Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Filing Support
                </Typography>
                <Typography variant="body1">
                  Upload thousands of 1042-S forms at once — ideal for
                  universities, payroll teams, financial institutions, and
                  global businesses.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/real-time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/real-time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/real-time-icon.png"
                      alt="Real-Time Status Updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Status Updates
                </Typography>
                <Typography variant="body1">
                  Track your IRS submission every step of the way.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  Transparent pricing designed for both single filers and large
                  enterprises.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Assistance "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Assistance
                </Typography>
                <Typography variant="body1">
                  TaxZerone’s support team provides guidance on income codes,
                  treaty benefits, and withholding requirements.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pb: 20,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                }}
              >
                Form 1042-S Deadlines for the 2025 Tax Year
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Stay compliant with the IRS deadlines for reporting payments to
                foreign individuals and entities.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            mb={0}
            py={{ xs: 0, sm: 4, md: 5 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={12}>
              <Box
                component="div"
                sx={{
                  mb: 3,
                  maxWidth: 600,
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  borderRadius: 3,
                  m: 'auto',
                }}
              >
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 500,
                            fontWeight: 600,
                            fontSize: 18,
                          }}
                        >
                          Filing Requirement
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 18,
                          }}
                        >
                          Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{}}>
                        <TableCell>Furnish recipient copies </TableCell>

                        <TableCell sx={{ fontWeight: 600 }}>
                          March 16, 2026{' '}
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell>
                          File Form 1042-S with IRS (electronic){' '}
                        </TableCell>

                        <TableCell sx={{ fontWeight: 600 }}>
                          March 16, 2026{' '}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            <Grid size={12} sx={{}}>
              <Box sx={{ maxWidth: 600, mx: 'auto' }}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, textAlign: 'left ' }}
                >
                  Summary{' '}
                </Typography>
                <Box component="ul" sx={{ mb: 1.2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> March 16, 2026 →</span>{' '}
                    Provide copies to foreign recipients{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>March 16, 2026 →</span>{' '}
                    E-file Form 1042-S with the IRS{' '}
                  </li>
                </Box>
              </Box>
            </Grid>
            <Grid size={12} sx={{}}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
                >
                  E-file Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <Container
          maxWidth="lg"
          sx={{
            mb: 6,
            mt: { xs: -15, sm: -20 },
            backgroundColor: '#1d2337',
            backgroundBlendMode: 'soft-light',
            borderRadius: 4,
            px: { xs: 2, sm: 3 },
            py: 6,
            textAlign: 'center',
          }}
          className="curve-bg"
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              textAlign: 'center',
              color: '#fff',
            }}
          >
            Running Out of Time? File for an Extension
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: '#909090' }}>
            Get additional time to file or send recipient copies by requesting
            an extension below.
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            mx={2}
            mt={{ xs: 4, md: 4 }}
            pb={0}
            className="MuiGrid-root-width"
            sx={{}}
          >
            <Grid
              size={{ xs: 12, md: 6, sm: 6 }}
              textAlign="center"
              sx={{
                pt: '0 !important',
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, .75)',
                  backgroundBlendMode: 'soft-light',
                  borderRadius: 4,
                  px: { xs: 2, lg: 2 },
                  py: 3,
                  minHeight: '100%',
                  border: '2px solid #353b4e',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    color: '#ccc',
                  }}
                >
                  Form 8809
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, color: '#a2a2a2' }}>
                  Request an Extension to File Information Returns
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    m: 0,
                    mt: 2,
                  }}
                >
                  <List sx={{ mb: 0 }}>
                    <ListItem
                      sx={{
                        py: 0.5,
                        alignItems: 'flex-start',
                        textAlign: 'center',
                        p: 0,
                      }}
                    >
                      <ListItemText sx={{ color: '#ccc' }}>
                        Need more time to file your{' '}
                        <span style={{ fontWeight: 600 }}>1042 s form?</span>{' '}
                        <Link
                          href="/tax-extension/efile-irs-form-8809-online/"
                          sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                        >
                          E-file Form 8809
                        </Link>{' '}
                        to request an{' '}
                        <span style={{ fontWeight: 600 }}>
                          automatic 30-day extension
                        </span>{' '}
                        to file 1042s Form with the IRS.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 6 }}
              textAlign="center"
              sx={{
                pt: { sm: '0 !important' },
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, .75)',
                  backgroundBlendMode: 'soft-light',
                  borderRadius: 4,
                  px: { xs: 2, lg: 2 },
                  py: 3,
                  minHeight: '100%',
                  border: '2px solid #353b4e',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    color: '#ccc',
                  }}
                >
                  Form 15397
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, color: '#909090' }}>
                  Request an Extension to Furnish Recipient Statements
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    m: 0,
                    mt: 2,
                  }}
                >
                  <List sx={{ mb: 0 }}>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start', p: 0 }}>
                      <ListItemText sx={{ color: '#ccc', textAlign: 'center' }}>
                        Need more time to send recipient copies of 1042-s form?{' '}
                        <Link
                          href="/tax-extension/file-irs-form-15397-online/"
                          sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                        >
                          File Form 15397
                        </Link>{' '}
                        to request a{' '}
                        <span style={{ fontWeight: 600 }}>
                          one-time 30-day extension
                        </span>{' '}
                        to furnish 1042s recipient statements.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} textAlign="center">
              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-secondary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
              >
                Get Extension Now
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 1, fontSize: { xs: 11, sm: 14 }, color: '#a2a2a2' }}
              >
                File Extension in Mins
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Form 1042-S Penalties
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center', mb: 3 }}>
                The IRS imposes penalties if you file Form 1042-S late, submit
                incorrect information, or fail to furnish recipient copies on
                time.
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>{' '}
                Penalties apply{' '}
                <span style={{ fontWeight: 600 }}> per form,</span> which can
                become costly for high-volume filers.
              </Typography>
            </Grid>

            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  py: { xs: 2, sm: 4, md: 4 },
                  px: { xs: 2, sm: 4, md: 6 },
                  borderRadius: 10,
                  backgroundColor: '#f5f6f7',
                  maxWidth: 850,
                  mx: 'auto',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 24, md: 20, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 4,
                    textAlign: 'center',
                  }}
                >
                  Penalties for Late Filing With the IRS
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                  If you fail to file a correct Form 1042-S by the due date
                  (including extensions), and no reasonable cause applies, the
                  IRS may impose the following penalties:
                </Typography>

                <Box
                  sx={{
                    justifyContent: 'center',
                    maxWidth: 650,
                    mx: 'auto',
                  }}
                >
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <span style={{ fontWeight: 600 }}> $60 per form</span>{' '}
                        if filed within{' '}
                        <span style={{ fontWeight: 600 }}>30 days</span> after
                        the due date Maximum:{' '}
                        <span style={{ fontWeight: 600 }}>
                          $683,000 per year
                        </span>{' '}
                        (or <span style={{ fontWeight: 600 }}>$239,000</span>{' '}
                        for small businesses)
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <span style={{ fontWeight: 600 }}> $130 per form</span>{' '}
                        if filed more than 30 days late but{' '}
                        <span style={{ fontWeight: 600 }}>
                          on or before August 1
                        </span>{' '}
                        Maximum:{' '}
                        <span style={{ fontWeight: 600 }}>
                          $2,049,000 per year
                        </span>{' '}
                        (or <span style={{ fontWeight: 600 }}>$683,000</span>{' '}
                        for small businesses){' '}
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <span style={{ fontWeight: 600 }}> $340 per form</span>{' '}
                        if filed{' '}
                        <span style={{ fontWeight: 600 }}>after August 1</span>{' '}
                        or{' '}
                        <span style={{ fontWeight: 600 }}>
                          not filed at all
                        </span>{' '}
                        Maximum:{' '}
                        <span style={{ fontWeight: 600 }}>
                          $4,098,500 per year
                        </span>{' '}
                        (or <span style={{ fontWeight: 600 }}>$1,366,000</span>{' '}
                        for small businesses)
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography variant="body1" sx={{ textAlign: 'left' }}>
                  A small business is defined as having average annual gross
                  receipts of $5 million or less for the previous 3 tax years.
                </Typography>
                {/* <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 0,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                  >
                    File 1099-DA Now!
                  </Button>
                </Box> */}
              </Paper>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  background: '#e9edc9',
                  p: 3,
                  py: 5,

                  justifyContent: 'center',
                  borderRadius: 4,
                  minHeight: '100%',
                  alignContent: 'stretch',
                }}
              >
                <Box sx={{ mb: 18 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 18 },
                      mb: 1,
                    }}
                  >
                    Penalties for Incorrect or Incomplete Forms{' '}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    These penalties apply to errors such as missing or invalid
                    TINs, incorrect income codes, wrong Chapter 3/4 status,
                    incorrect treaty benefit claims, or mismatched withholding
                    amounts.
                  </Typography>
                  <Typography variant="body1">
                    Penalty amounts follow the{' '}
                    <span style={{ fontWeight: 600 }}> same three tiers</span>{' '}
                    as late filing penalties.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    height: 200,
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/images/incompeted-form-img.webp"
                    alt="Penalties for Incorrect or Incomplete Forms"
                    loading="lazy"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 4,
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  background: '#dbf4f9ff',
                  p: 3,
                  py: 5,
                  borderRadius: 4,
                  minHeight: '100%',
                  alignContent: 'space-between',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 18 },
                      mb: 1,
                    }}
                  >
                    Penalties for Failure to Furnish Recipient Copies
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    You must provide correct{' '}
                    <span style={{ fontWeight: 600 }}> Copies B, C, and D</span>{' '}
                    of Form 1042-S to recipients by the required deadline.
                    Penalties may apply separately from IRS filing penalties:
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                    <li>
                      Up to{' '}
                      <span style={{ fontWeight: 600 }}>$340 per failure,</span>{' '}
                      with a maximum of{' '}
                      <span style={{ fontWeight: 600 }}>$4,098,500</span>{' '}
                      <span style={{ fontStyle: 'italic' }}>
                        ($1,366,000 for small businesses)
                      </span>{' '}
                    </li>
                    <li>
                      Reduced penalties apply if recipient copies are furnished{' '}
                      <span style={{ fontWeight: 600 }}>by August 1,</span>{' '}
                      matching IRS late-filing penalty tiers.{' '}
                    </li>
                  </Box>
                </Box>
                <Box sx={{ width: '100%', display: 'flex', height: 200 }}>
                  <Box
                    component="img"
                    src="/assets/images/copies-failure-img.webp"
                    alt="Penalties for Failure to Furnish Recipient Copies"
                    loading="lazy"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 4,
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  background: '#ffedd8',
                  p: 3,
                  py: 5,
                  borderRadius: 4,
                  minHeight: '100%',
                  alignContent: 'space-around',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 18 },
                      mb: 1,
                    }}
                  >
                    Intentional Disregard Penalty
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    If the IRS determines intentional disregard of filing or
                    furnishing requirements:
                  </Typography>
                  <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                    <li>
                      Penalty is the{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        greater of $680 per form or 10% of the amount that
                        should have been reported
                      </span>
                    </li>
                    <li style={{ fontWeight: 600 }}>
                      No maximum limit applies{' '}
                    </li>
                    <li>
                      Also applies when electronic filing is required but not
                      completed, without a waiver or reasonable cause.{' '}
                    </li>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    height: 200,
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/images/intentional-disregard-img.webp"
                    alt="Intentional Disregard Penalty"
                    loading="lazy"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 4,
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                Extension to File Form 1042-S (Form 8809)
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                If you need more time to file Form 1042-S with the IRS, you can
                request an automatic extension by submitting{' '}
                <Link
                  href="/tax-extension/efile-irs-form-8809-online/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  Form 8809
                </Link>
                ,{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Application for Extension of Time to File Information Returns.
                </span>
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 22, sm: 18, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                How the 1042-S Filing Extension Works
              </Typography>

              <List
                sx={{
                  display: 'inline-block',
                  mb: 2,
                }}
              >
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: -2.5 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    <Link
                      href="/tax-extension/efile-irs-form-8809-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Filing Form 8809
                    </Link>{' '}
                    provides a{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      30-day automatic extension
                    </span>{' '}
                    to file Form 1042-S with the IRS.
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: -3 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    You must submit Form 8809{' '}
                    <span style={{ fontWeight: 600 }}>
                      on or before March 15
                    </span>{' '}
                    (the original filing deadline).
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: -5.8 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    The extension applies{' '}
                    <span style={{ fontWeight: 600 }}>
                      only to filing with the IRS — it does NOT extend the
                      deadline to furnish recipient copies,
                    </span>{' '}
                    which must still be provided by{' '}
                    <span style={{ fontWeight: 600 }}>March 15</span>.
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1042s-extension-file-img.webp" />
                  <source srcSet="/assets/images/f1042s-extension-file-img.png" />
                  <img
                    src="/assets/images/f1042s-extension-file-img.png"
                    alt="Extension to File Form 1042-S (Form 8809)"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            spacing={2}
            mt={2}
            // py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1042s-common-error-img.webp" />
                  <source srcSet="/assets/images/f1042s-common-error-img.png" />
                  <img
                    src="/assets/images/f1042s-common-error-img.png"
                    alt="Common Errors When Filing Form 1042-S "
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 6 }}
              sx={{
                textAlign: 'left',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'left',
                  }}
                >
                  Common Errors When Filing Form 1042-S
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'left' }}>
                  Avoid these frequent mistakes to prevent IRS rejections:
                </Typography>
                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Incorrect income code or exemption code
                    </ListItemText>
                  </ListItem>
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Wrong withholding rate or treaty claim
                    </ListItemText>
                  </ListItem>
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Mismatched recipient information
                    </ListItemText>
                  </ListItem>
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Missing Chapter 4 (FATCA) classification
                    </ListItemText>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Reporting U.S. person income incorrectly
                    </ListItemText>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Late submissions or incorrect tax year
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                How to Amend an Error on <br /> Form 1042-S
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Made a mistake? You can easily file an amendment.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                To amend Form 1042-S:
              </Typography>

              <List
                sx={{
                  display: 'inline-block',
                  mb: 2,
                }}
              >
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Check the{' '}
                    <span style={{ fontWeight: 600 }}> “Amended”</span> box on
                    the form
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Update the information with the correct details
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Retransmit the amended form electronically
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>Send updated recipient copies</ListItemText>
                </ListItem>
              </List>
              <Typography variant="body1" sx={{ mb: 1 }}>
                With TaxZerone, amending Form 1042-S is simple — just update the
                form and resubmit. No paper forms required.
              </Typography>
              <Box sx={{ mt: 3, textAlign: 'left' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
                >
                  E-file Now
                </Button>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1042s-correction-img.webp" />
                  <source srcSet="/assets/images/f1042s-correction-img.png" />
                  <img
                    src="/assets/images/f1042s-correction-img.png"
                    alt="How to Amend an Error on Form 1042-S "
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Simplify Your Form 1042-S Filing with TaxZerone
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 0,
            lineHeight: 1.5,
          }}
        >
          TaxZerone makes foreign income reporting fast, reliable, and
          stress-free:
        </Typography>
        <Box
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
            }}
          >
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Built-in validations for codes, rates, and classifications
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Quick and guided filing workflow
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Simple bulk-upload functionality
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Transparent and competitive pricing
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Fully encrypted and secure e-filing
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Stack>
        </Box>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1042s`}
          >
            Start Filing Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, md: 9, sm: 10 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 3 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is the difference between Form 1042 and Form 1042-S?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Form <span style={{ fontWeight: 600 }}> 1042-S</span>{' '}
                      reports U.S.-source income and withholding for each
                      foreign recipient.
                    </Typography>
                    <Typography component="div" sx={{ mt: 1 }}>
                      Form <span style={{ fontWeight: 600 }}>1042</span>{' '}
                      summarizes total annual withholding activity for the
                      withholding agent.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What information is required to e-file Form 1042-S?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      You’ll need:
                    </Typography>
                    <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                      <li>Withholding agent details (name, EIN, address) </li>
                      <li>
                        Recipient information (name, foreign address, TIN/ITIN
                        if applicable){' '}
                      </li>
                      <li>Income codes and exemption codes </li>
                      <li>Tax rate or treaty claim </li>
                      <li>Federal tax withheld </li>
                      <li>Chapter 3 or Chapter 4 status </li>
                      <li>Any adjustments or corrections </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Are treaty benefits reported on Form 1042-S?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Yes. If a tax treaty reduces or eliminates withholding,
                      you must:
                    </Typography>
                    <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                      <li>Enter the treaty country </li>
                      <li>Report the applicable treaty article </li>
                      <li>Use the correct exemption code </li>
                      <li>Apply the correct reduced tax rate </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Do I need to file Form 1042-S if no tax was withheld?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Yes. Even if withholding is{' '}
                      <span style={{ fontWeight: 600 }}> 0%,</span> you must
                      file Form 1042-S if the payment is:{' '}
                    </Typography>
                    <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                      <li>U.S.-source </li>
                      <li>Made to a foreign person </li>
                      <li>Reportable under IRS rules </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Can I file multiple 1042-S forms electronically?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Absolutely. TaxZerone supports bulk filing via spreadsheet
                      upload, allowing organizations to submit hundreds or
                      thousands of forms efficiently.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1042S;
